import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'ctr-target-login',
  imports: [],
  templateUrl: './targetLogin.component.html',
  styleUrl: './targetLogin.component.scss',
})
export class TargetLoginComponent {
  @Input() text = '';
  @Input() image = '';
  @Input() platform = '';
  @Output() eventBtn: EventEmitter<void> = new EventEmitter();
  emit() {
    this.eventBtn.emit();
  }
}
